module.exports = __webpack_public_path__ + "img/company.5354106d.png";